var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsultantDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_982",
    "data-name": "Group 982",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 24,
    height: 24,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M8.4,14.4h-6A2.4,2.4,0,0,1,0,12V2.4A2.4,2.4,0,0,1,2.4,0h6a2.4,2.4,0,0,1,2.4,2.4V12a2.4,2.4,0,0,1-2.4,2.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M8.4,71.92a.48.48,0,0,1,.48.48v2.4a.48.48,0,0,1-.48.48h-6a.48.48,0,0,1-.48-.48V72.4a.48.48,0,0,1,.48-.48ZM8.4,70h-6A2.4,2.4,0,0,0,0,72.4v2.4a2.4,2.4,0,0,0,2.4,2.4h6a2.4,2.4,0,0,0,2.4-2.4V72.4A2.4,2.4,0,0,0,8.4,70",
    transform: "translate(0 -53.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M57.4,40h6a2.4,2.4,0,0,1,2.4,2.4V52a2.4,2.4,0,0,1-2.4,2.4h-6A2.4,2.4,0,0,1,55,52V42.4A2.4,2.4,0,0,1,57.4,40",
    transform: "translate(-41.8 -30.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M63.4,1.92a.48.48,0,0,1,.48.48V4.8a.48.48,0,0,1-.48.48h-6a.48.48,0,0,1-.48-.48V2.4a.48.48,0,0,1,.48-.48ZM63.4,0h-6A2.4,2.4,0,0,0,55,2.4V4.8a2.4,2.4,0,0,0,2.4,2.4h6a2.4,2.4,0,0,0,2.4-2.4V2.4A2.4,2.4,0,0,0,63.4,0",
    transform: "translate(-41.8)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultantDashboardIcon);
export default __webpack_public_path__ + "static/media/consultant_dashboard_icon.d6432717d922931ccdb87e659a724a08.svg";
export { ForwardRef as ReactComponent };